import { render, staticRenderFns } from "./ModalHomeCategoryStep2.vue?vue&type=template&id=06bd43c7"
import script from "./ModalHomeCategoryStep2.vue?vue&type=script&lang=js"
export * from "./ModalHomeCategoryStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports